/* eslint-disable */
import styled from 'styled-components';

const Wrap = styled.div``;

export {
    Wrap,
};
